export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: '・개선 계획에 기재하는 내용은 {toCompanyName}에 표시됩니다.\n・첨부 파일은 파일명만 {toCompanyName}(으)로 표시되고, 파일의 내용은 공유되지 않습니다.',
    },
    chat: {
      card_title: '메시지',
      input_area_description: '개선 계획에 관하여 {toCompanyName}에 메시지를 보낼 수 있습니다.',
      send_confirm: {
        modal_title: '메시지 송신 확인',
        confirm_text: '이 메시지를 송신해도 되겠습니까?',
        confirm_text_near_by_check_box: '메시지를 확인함.',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        // toast_text:
      },
      delete_confirm: {
        modal_title: '메시지 삭제 확인',
        confirm_text: '이 메시지를 삭제해도 되겠습니까?',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: '송수신 이력',
        send_status: {
          success: '송신 완료',
          failure: '송신 실패',
        },
      },
    },
  },
}
